import React, {useState} from 'react'
import {Question} from 'organization/Event/QuestionsProvider'
import Box from 'lib/ui/Box'
import Button from 'lib/ui/Button'
import {api} from 'lib/url'
import {useOrganization} from 'organization/OrganizationProvider'
import {makeStyles} from '@material-ui/core/styles'
import {
  DEFAULT_SNACKBAR_SUCCESS_BACKGROUND_COLOR,
  DEFAULT_SNACKBAR_SUCCESS_COLOR,
  useSnackbar,
} from 'lib/ui/SnackbarProvider'

export default function ExportSubmission(props: {question?: Question}) {
  const isSaved = typeof props.question?.id === 'number'
  if (!props.question || !isSaved) {
    return null
  }
  return <Export question={props.question} />
}

function Export(props: {question: Question}) {
  const {client} = useOrganization()
  const {enqueueSnackbar} = useSnackbar()
  const classes = useStyles()
  const [isProcessing, setIsProcessing] = useState(false)

  const exportSubmissions = () => {
    setIsProcessing(true)
    client
      .get(api(`/questions/${props.question.id}/submissions`))
      .then(() => {
        enqueueSnackbar(
          "We're preparing your download. You'll receive an email with the link when it's ready.",
          {variant: 'success', className: classes.success},
        )
      })
      .catch((e) => {
        enqueueSnackbar(e.message, {variant: 'error'})
      })
      .finally(() => setIsProcessing(false))
  }

  return (
    <Box textAlign="right" mb={3}>
      <Button
        onClick={exportSubmissions}
        variant="outlined"
        aria-label={`export ${props.question.label} submissions`}
        disabled={isProcessing}
        color="primary"
      >
        Download Submission
      </Button>
    </Box>
  )
}

const useStyles = makeStyles({
  success: {
    '&&': {
      backgroundColor: `${DEFAULT_SNACKBAR_SUCCESS_BACKGROUND_COLOR} !important`,
      color: `${DEFAULT_SNACKBAR_SUCCESS_COLOR} !important`,
    },
  },
})
